import { NotificationWindowOptions } from '@frontend/shell-utils';
import { createStore } from '@frontend/store';

type NotificationsStore = {
  placement: NotificationWindowOptions['placement'];
  mode: 'new';
};

//This makes sure we have backwards compatibility until the user has updated to the latest version of the app
const modePlacementFeature = window.shell?.featureAvailability?.has?.('mode-placement');

export const useNotificationsStore = createStore<NotificationsStore>(
  () => ({
    mode: 'new',
    placement: 'top-right',
  }),
  {
    name: 'notifications-store',
  }
);

if (window.shell) {
  if (modePlacementFeature) {
    window.shell?.invoke('notification:initial-state', undefined).then((state) => {
      if (!state) return;
      useNotificationsStore.setState({
        placement: state.placement,
      });
    });
  }
}
